
import {map, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {InfoFichaDashboard, Periodo} from "../_models/interfaces";
import {SharedService} from "./shared.service";
import {Observable} from 'rxjs';


import {ThrobberService} from "./throbber.service";
import { HttpClient } from "@angular/common/http";

const API_URL = environment.apiUrl;

@Injectable()
export class DashboardService {
    private dashboardUrl;
    private periodosUrl;

    constructor(private http: HttpClient, private ss: SharedService, private throbServ: ThrobberService) { //, private hr: WindowRefService) {
        //this.win = hr.nativeWindow;
        this.dashboardUrl = `api/Dashboard`;
        this.periodosUrl = `api/Periodos`;
    }


    getDashboard(id: number = 0, periodoId: number = 0): Observable<InfoFichaDashboard[]> {
        this.throbServ.setThrobberState(true);
        return this.http.get(`${API_URL}/${this.dashboardUrl}/${id}/${periodoId}`).pipe(
            map(this.ss.extractData),
            tap(() => this.throbServ.setThrobberState(false)),)
            // .catch(this.ss.handleErrorObservable)
            // .do(() => this.throbServ.setThrobberState(false));
    }

    getPeriodos(year: boolean = false): Observable<Periodo[]>{
        this.throbServ.setThrobberState(true);
        return this.http.get(`${API_URL}/${this.periodosUrl}/${year}`).pipe(
            map(this.ss.extractData),
            tap(() => this.throbServ.setThrobberState(false)),)
            // .catch(this.ss.handleErrorObservable)
            // .do(() => this.throbServ.setThrobberState(false));
    }
}
